import { useEffect } from "react";

const DEFAULT_TITLE = "Meridian Vanguard Solutions, LLC";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO: title, description, OG/Twitter tags, canonical, breadcrumb schema.
 */
export function useSeo({ title, description, path = "/", breadcrumb = [] }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Meridian Vanguard Solutions` : DEFAULT_TITLE;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);

    const origin = window.location.origin;
    setCanonical(`${origin}${path}`);
    setMeta("property", "og:url", `${origin}${path}`);

    let schemaEl = document.getElementById("mv-breadcrumb-schema");
    if (breadcrumb.length) {
      const data = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${origin}${b.path}`,
        })),
      };
      if (!schemaEl) {
        schemaEl = document.createElement("script");
        schemaEl.type = "application/ld+json";
        schemaEl.id = "mv-breadcrumb-schema";
        document.head.appendChild(schemaEl);
      }
      schemaEl.textContent = JSON.stringify(data);
    } else if (schemaEl) {
      schemaEl.remove();
    }

    window.scrollTo({ top: 0, behavior: "auto" });
  }, [title, description, path, breadcrumb]);
}
